package br.com.htms.inspeccaocampo.ui.kit

import androidx.compose.material3.RadioButtonDefaults
import androidx.compose.material3.RadioButton
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.selected
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.graphics.Shape
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.ButtonElevation
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.Button
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material3.DropdownMenu
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.window.PopupProperties
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshots.Snapshot
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.layout.positionInRoot
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.abs
import kotlin.math.roundToInt
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.delay
import br.com.htms.inspeccaocampo.ui.theme.PortalCores

/** Componentes visuais comuns do portal, no padrão do Controle de Ativos. */

/** Topo visível da área rolável do módulo, em coordenadas da tela. */
class AncoraRolagem {
    var topo by mutableFloatStateOf(0f)
}

/** Base do cartão que limita até onde o painel grudado pode descer. */
class LimiteCartao {
    var base by mutableFloatStateOf(Float.POSITIVE_INFINITY)
}

val LocalAncoraRolagem = staticCompositionLocalOf<AncoraRolagem?> { null }
val LocalLimiteCartao = staticCompositionLocalOf<LimiteCartao?> { null }
val LocalRolagemPainel = staticCompositionLocalOf<ScrollState?> { null }

private fun deslocamentoPainel(
    scroll: ScrollState,
    ancora: AncoraRolagem,
    limite: LimiteCartao?,
    yConteudo: Float,
    h: Int,
    medido: Boolean
): Int {
    if (!medido || h <= 0) return 0
    val rolado = scroll.value.toFloat()
    val yNaTela = yConteudo - rolado
    val baseNaTela = (limite?.base ?: Float.POSITIVE_INFINITY) - rolado
    val bruto = (ancora.topo - yNaTela).coerceAtLeast(0f)
    val maximo = (baseNaTela - h - yNaTela).coerceAtLeast(0f)
    if (maximo <= 0f) return 0
    return bruto.coerceAtMost(maximo).roundToInt()
}

/**
 * Mantém o bloco no topo da área rolável enquanto o cartão ainda está na tela.
 * Filtros e cabeçalho de lista usam isto para não sumir ao descer os itens.
 */
@Composable
fun PainelFixo(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
    val ancora = LocalAncoraRolagem.current
    val limite = LocalLimiteCartao.current
    val scroll = LocalRolagemPainel.current
    if (ancora == null || scroll == null) {
        Column(modifier.background(PortalCores.Cartao)) { content() }
        return
    }
    var yConteudo by remember { mutableFloatStateOf(0f) }
    var h by remember { mutableIntStateOf(0) }
    var medido by remember { mutableStateOf(false) }
    Box(modifier.zIndex(2f)) {
        // Posição no conteúdo (não na tela). Somar a rolagem deixa o valor parado,
        // então o painel não é recomposto a cada pixel — era isso que piscava.
        Box(
            Modifier.matchParentSize().onGloballyPositioned { coords ->
                // Sem observar o scroll: senão cada pixel relayouta o painel e a tela trava.
                val natural = Snapshot.withoutReadObservation {
                    coords.positionInRoot().y + scroll.value
                }
                if (!medido || abs(natural - yConteudo) > 1.5f) {
                    yConteudo = natural
                    medido = true
                }
            }
        )
        Column(
            Modifier
                .fillMaxWidth()
                .onSizeChanged { if (it.height != h) h = it.height }
                .offset {
                    IntOffset(0, deslocamentoPainel(scroll, ancora, limite, yConteudo, h, medido))
                }
                .drawWithContent {
                    drawContent()
                    val dy = deslocamentoPainel(scroll, ancora, limite, yConteudo, h, medido)
                    if (dy > 0) {
                        drawRect(
                            PortalCores.Borda,
                            topLeft = Offset(0f, size.height - 1f),
                            size = Size(size.width, 1f)
                        )
                    }
                }
                .background(PortalCores.Cartao)
        ) {
            content()
        }
    }
}

data class PortalMenuItem(
    val chave: String,
    val rotulo: String,
    val icone: ImageVector,
    /** Destaca o item em laranja (ex.: há pendências nele). */
    val destaque: Boolean = false,
    /** Faixa de seção (não clicável), ex.: "Emissão de Documentos". */
    val separador: Boolean = false
)

@Composable
fun PortalMenuLateral(itens: List<PortalMenuItem>, selecionado: String, onSelect: (String) -> Unit) {
    Row(Modifier.fillMaxHeight()) {
        Column(
            Modifier.width(240.dp).fillMaxHeight().background(PortalCores.Cartao).padding(horizontal = 14.dp, vertical = 22.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            itens.forEach { item ->
                if (item.separador) {
                    Text(
                        item.rotulo.uppercase(),
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(start = 14.dp, end = 14.dp, top = 14.dp, bottom = 6.dp),
                        color = PortalCores.CinzaTexto,
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.labelSmall,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis
                    )
                    return@forEach
                }
                val sel = item.chave == selecionado
                Row(
                    Modifier
                        .fillMaxWidth()
                        .background(if (sel) PortalCores.Marca else Color.Transparent, RoundedCornerShape(10.dp))
                        .clickable { onSelect(item.chave) }
                        .padding(horizontal = 14.dp, vertical = 12.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        item.icone,
                        contentDescription = null,
                        tint = if (sel) Color.White else PortalCores.TextoForte,
                        modifier = Modifier.size(20.dp)
                    )
                    Spacer(Modifier.width(12.dp))
                    Text(
                        item.rotulo,
                        color = when {
                            sel -> Color.White
                            item.destaque -> PortalCores.Laranja
                            else -> PortalCores.Texto
                        },
                        fontWeight = if (sel) FontWeight.SemiBold else FontWeight.Normal,
                        style = MaterialTheme.typography.bodyLarge,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }
        Box(Modifier.width(1.dp).fillMaxHeight().background(PortalCores.Borda))
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun PortalMenuChips(itens: List<PortalMenuItem>, selecionado: String, onSelect: (String) -> Unit) {
    FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
        itens.forEach { item ->
            if (item.separador) {
                Text(
                    item.rotulo,
                    modifier = Modifier.padding(horizontal = 4.dp, vertical = 8.dp),
                    color = PortalCores.CinzaTexto,
                    fontWeight = FontWeight.Bold,
                    style = MaterialTheme.typography.labelMedium
                )
                return@forEach
            }
            val sel = item.chave == selecionado
            Row(
                Modifier
                    .background(if (sel) PortalCores.Marca else PortalCores.Cartao, RoundedCornerShape(10.dp))
                    .border(1.dp, if (sel) PortalCores.Marca else PortalCores.Borda, RoundedCornerShape(10.dp))
                    .clickable { onSelect(item.chave) }
                    .padding(horizontal = 12.dp, vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(item.icone, contentDescription = null, tint = if (sel) Color.White else PortalCores.Navy, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(6.dp))
                Text(
                    item.rotulo,
                    color = if (sel) Color.White else if (item.destaque) PortalCores.Laranja else PortalCores.Navy,
                    style = MaterialTheme.typography.bodyMedium
                )
            }
        }
    }
}

/** Faixa branca com o título do módulo; [extra] fica à direita (status, botões). */
@Composable
fun PortalCabecalho(titulo: String, largo: Boolean, extra: @Composable RowScope.() -> Unit = {}) {
    Column(Modifier.fillMaxWidth().background(PortalCores.Cartao)) {
        Row(
            Modifier.fillMaxWidth().padding(horizontal = if (largo) 28.dp else 14.dp, vertical = if (largo) 18.dp else 12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                titulo,
                modifier = Modifier.weight(1f),
                color = PortalCores.Navy,
                fontWeight = FontWeight.Bold,
                style = if (largo) MaterialTheme.typography.headlineSmall else MaterialTheme.typography.titleMedium,
                maxLines = 2
            )
            extra()
        }
        HorizontalDivider(color = PortalCores.Borda)
    }
}

/**
 * Estrutura de módulo: menu lateral (tela larga) ou chips (celular), cabeçalho e conteúdo rolável.
 * [rolavel] = false quando o conteúdo já tem rolagem própria.
 */
@Composable
fun PortalModulo(
    titulo: String,
    itens: List<PortalMenuItem>,
    selecionado: String,
    onSelect: (String) -> Unit,
    extraCabecalho: @Composable RowScope.() -> Unit = {},
    rolavel: Boolean = true,
    conteudo: @Composable ColumnScope.(largo: Boolean) -> Unit
) {
    BoxWithConstraints(Modifier.fillMaxSize().background(PortalCores.FundoPainel)) {
        val largo = maxWidth >= 900.dp
        Row(Modifier.fillMaxSize()) {
            if (largo && itens.isNotEmpty()) PortalMenuLateral(itens, selecionado, onSelect)
            Column(Modifier.weight(1f).fillMaxHeight()) {
                PortalCabecalho(titulo, largo, extraCabecalho)
                if (rolavel) {
                    val scroll = rememberScrollState()
                    AreaRolavel(scroll, Modifier.fillMaxSize()) {
                        Column(
                            modifier = Modifier.fillMaxSize().verticalScroll(scroll).padding(if (largo) 24.dp else 12.dp),
                            verticalArrangement = Arrangement.spacedBy(18.dp)
                        ) {
                            if (!largo && itens.isNotEmpty()) PortalMenuChips(itens, selecionado, onSelect)
                            conteudo(largo)
                        }
                    }
                } else {
                    Column(
                        modifier = Modifier.fillMaxSize().padding(if (largo) 24.dp else 12.dp),
                        verticalArrangement = Arrangement.spacedBy(18.dp)
                    ) {
                        if (!largo && itens.isNotEmpty()) PortalMenuChips(itens, selecionado, onSelect)
                        conteudo(largo)
                    }
                }
            }
        }
    }
}

@Composable
fun CartaoBranco(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
    val limite = remember { LimiteCartao() }
    Card(
        modifier = modifier.border(1.dp, PortalCores.Borda, RoundedCornerShape(14.dp)),
        colors = CardDefaults.cardColors(containerColor = PortalCores.Cartao),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
        shape = RoundedCornerShape(14.dp)
    ) {
        CompositionLocalProvider(LocalLimiteCartao provides limite) {
            val scrollPainel = LocalRolagemPainel.current
            Box(Modifier.onGloballyPositioned { coords ->
                val b = Snapshot.withoutReadObservation {
                    coords.positionInRoot().y + coords.size.height + (scrollPainel?.value ?: 0)
                }
                if (abs(b - limite.base) > 1.5f) limite.base = b
            }) {
                content()
            }
        }
    }
}

/** Cartão branco com título (e ações à direita) e conteúdo com espaçamento padrão. */
@Composable
fun CartaoSecao(
    titulo: String,
    modifier: Modifier = Modifier.fillMaxWidth(),
    subtitulo: String = "",
    acoes: @Composable RowScope.() -> Unit = {},
    content: @Composable ColumnScope.() -> Unit
) {
    CartaoBranco(modifier) {
        Column(Modifier.fillMaxWidth().padding(18.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    Text(titulo, color = PortalCores.Navy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleLarge)
                    if (subtitulo.isNotBlank()) {
                        Text(subtitulo, color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
                    }
                }
                acoes()
            }
            content()
        }
    }
}

@Composable
fun PortalModal(onFechar: () -> Unit, larguraMax: Dp = 780.dp, content: @Composable () -> Unit) {
    Dialog(
        onDismissRequest = onFechar,
        properties = DialogProperties(usePlatformDefaultWidth = false, dismissOnClickOutside = false)
    ) {
        Box(Modifier.fillMaxSize().background(Color.Black.copy(alpha = 0.45f)), contentAlignment = Alignment.Center) {
            val scroll = rememberScrollState()
            AreaRolavel(scroll, Modifier.padding(16.dp).widthIn(max = larguraMax).fillMaxWidth(), botoes = false) {
                Column(
                    Modifier
                        .fillMaxWidth()
                        .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null) {}
                        .verticalScroll(scroll)
                ) { content() }
            }
        }
    }
}

@Composable
fun Kpi(
    titulo: String,
    valor: String,
    icone: ImageVector,
    modifier: Modifier,
    alerta: Boolean = false,
    cor: Color? = null,
    legenda: String = "",
    onClick: (() -> Unit)? = null
) {
    val fundo = if (alerta) PortalCores.FundoAlerta else PortalCores.Cartao
    val borda = if (alerta) PortalCores.BordaAlerta else PortalCores.Borda
    val corValor = cor ?: if (alerta) PortalCores.Laranja else PortalCores.Navy
    val corIcone = cor ?: if (alerta) PortalCores.Laranja else PortalCores.AzulIcone
    Row(
        modifier
            .background(fundo, RoundedCornerShape(14.dp))
            .border(1.dp, borda, RoundedCornerShape(14.dp))
            .let { if (onClick != null) it.clickable { onClick() } else it }
            .padding(horizontal = 22.dp, vertical = 20.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(6.dp)) {
            Text(titulo, color = PortalCores.TextoForte, style = MaterialTheme.typography.bodyLarge)
            Text(valor, color = corValor, fontWeight = FontWeight.Bold, fontSize = 34.sp)
            if (legenda.isNotBlank()) Text(legenda, color = PortalCores.CinzaTexto, style = MaterialTheme.typography.bodySmall)
        }
        Icon(icone, contentDescription = null, tint = corIcone, modifier = Modifier.size(40.dp))
    }
}

/** Linha de KPIs: lado a lado na tela larga, empilhados no celular. */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun LinhaKpis(largo: Boolean, kpis: @Composable (Modifier) -> Unit) {
    if (largo) {
        Row(horizontalArrangement = Arrangement.spacedBy(18.dp), modifier = Modifier.fillMaxWidth()) {
            kpis(Modifier.weight(1f))
        }
    } else {
        Column(verticalArrangement = Arrangement.spacedBy(10.dp)) { kpis(Modifier.fillMaxWidth()) }
    }
}

@Composable
fun CampoBusca(valor: String, onChange: (String) -> Unit, placeholder: String, modifier: Modifier) {
    OutlinedTextField(
        value = valor,
        onValueChange = onChange,
        modifier = modifier,
        singleLine = true,
        placeholder = { Text(placeholder, color = PortalCores.CinzaClaro) },
        leadingIcon = { Icon(Icons.Filled.Search, contentDescription = null, tint = PortalCores.CinzaClaro) },
        shape = RoundedCornerShape(10.dp),
        colors = OutlinedTextFieldDefaults.colors(
            focusedBorderColor = PortalCores.Navy,
            unfocusedBorderColor = PortalCores.BordaCampo,
            focusedContainerColor = PortalCores.Cartao,
            unfocusedContainerColor = PortalCores.Cartao,
            focusedTextColor = PortalCores.Texto,
            unfocusedTextColor = PortalCores.Texto,
            cursorColor = PortalCores.AzulIcone
        )
    )
}

@Composable
fun RowScope.Celula(texto: String, peso: Float, negrito: Boolean = false, cor: Color = PortalCores.Texto, linhas: Int = 2) {
    Text(
        texto,
        modifier = Modifier.weight(peso).padding(end = 10.dp),
        style = MaterialTheme.typography.bodyMedium,
        fontWeight = if (negrito) FontWeight.SemiBold else FontWeight.Normal,
        color = cor,
        maxLines = linhas,
        overflow = if (linhas > 4) TextOverflow.Visible else TextOverflow.Ellipsis,
        softWrap = true
    )
}

@Composable
fun RowScope.CelulaCabecalho(texto: String, peso: Float) {
    Text(
        texto,
        modifier = Modifier.weight(peso).padding(end = 10.dp),
        style = MaterialTheme.typography.bodyMedium,
        fontWeight = FontWeight.SemiBold,
        color = PortalCores.TextoForte,
        maxLines = 1
    )
}

/** Cabeçalho clicável: alterna crescente/decrescente. [crescente] null = coluna não é a ordenação atual. */
@Composable
fun RowScope.CelulaCabecalhoOrdenavel(texto: String, peso: Float, crescente: Boolean?, onClick: () -> Unit) {
    Row(
        Modifier.weight(peso).padding(end = 10.dp).clip(RoundedCornerShape(6.dp)).clickable(onClick = onClick),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            texto,
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.SemiBold,
            color = if (crescente != null) PortalCores.Navy else PortalCores.TextoForte,
            maxLines = 2,
            overflow = TextOverflow.Clip,
            modifier = Modifier.weight(1f, fill = false)
        )
        Icon(
            if (crescente == true) Icons.Filled.KeyboardArrowUp else Icons.Filled.KeyboardArrowDown,
            contentDescription = when (crescente) {
                true -> "Crescente"
                false -> "Decrescente"
                null -> "Ordenar"
            },
            tint = if (crescente != null) PortalCores.Navy else PortalCores.CinzaTexto.copy(alpha = 0.45f),
            modifier = Modifier.size(18.dp)
        )
    }
}

class OrdemColuna(inicial: String) {
    var col by mutableStateOf(inicial)
    var asc by mutableStateOf(true)
    fun clique(c: String) {
        if (col == c) asc = !asc else {
            col = c
            asc = true
        }
    }
    fun marca(c: String): Boolean? = if (col == c) asc else null
    fun <T> aplicar(lista: List<T>, chave: (T) -> String): List<T> = lista.sortedWith(Ordenacao.por(asc, chave))
}

@Composable
fun rememberOrdem(inicial: String): OrdemColuna = remember { OrdemColuna(inicial) }

object Ordenacao {
    private fun semAcento(s: String): String = buildString(s.length) {
        for (ch in s.trim().lowercase()) {
            append(
                when (ch) {
                    'á', 'à', 'â', 'ã', 'ä' -> 'a'
                    'é', 'è', 'ê', 'ë' -> 'e'
                    'í', 'ì', 'î', 'ï' -> 'i'
                    'ó', 'ò', 'ô', 'õ', 'ö' -> 'o'
                    'ú', 'ù', 'û', 'ü' -> 'u'
                    'ç' -> 'c'
                    else -> ch
                }
            )
        }
    }

    /** Compara texto ignorando acentos/maiúsculas, com números em ordem numérica ("A-2" antes de "A-10"). */
    fun natural(a: String, b: String): Int {
        val x = semAcento(a)
        val y = semAcento(b)
        var i = 0
        var j = 0
        while (i < x.length && j < y.length) {
            if (x[i].isDigit() && y[j].isDigit()) {
                val ii = i
                val jj = j
                while (i < x.length && x[i].isDigit()) i++
                while (j < y.length && y[j].isDigit()) j++
                val nx = x.substring(ii, i).trimStart('0')
                val ny = y.substring(jj, j).trimStart('0')
                if (nx.length != ny.length) return nx.length - ny.length
                val c = nx.compareTo(ny)
                if (c != 0) return c
            } else {
                val c = x[i].compareTo(y[j])
                if (c != 0) return c
                i++
                j++
            }
        }
        return (x.length - i) - (y.length - j)
    }

    /** Vazios sempre no fim, nos dois sentidos. */
    fun <T> por(crescente: Boolean, chave: (T) -> String): Comparator<T> = Comparator { p, q ->
        val a = chave(p)
        val b = chave(q)
        when {
            a.isBlank() && b.isBlank() -> 0
            a.isBlank() -> 1
            b.isBlank() -> -1
            else -> if (crescente) natural(a, b) else natural(b, a)
        }
    }

    fun <T> porNumero(crescente: Boolean, chave: (T) -> Double?): Comparator<T> = Comparator { p, q ->
        val a = chave(p)
        val b = chave(q)
        when {
            a == null && b == null -> 0
            a == null -> 1
            b == null -> -1
            else -> if (crescente) a.compareTo(b) else b.compareTo(a)
        }
    }

    fun contem(texto: String, termo: String): Boolean = semAcento(texto).contains(semAcento(termo))
}

/**
 * Lista suspensa em que também dá para digitar e filtrar as opções.
 * O menu não pode ser focável: no web, um popup focável tira o teclado do campo.
 */
@Composable
fun SeletorBusca(
    label: String,
    opcoes: List<Pair<String, String>>,
    selecionado: String,
    onSelect: (String) -> Unit,
    modifier: Modifier = Modifier.fillMaxWidth(),
    isError: Boolean = false,
    supportingText: (@Composable () -> Unit)? = null,
    embutido: Boolean = false
) {
    var aberto by remember { mutableStateOf(false) }
    var focado by remember { mutableStateOf(false) }
    var texto by remember { mutableStateOf("") }
    var geracao by remember { mutableIntStateOf(0) }
    var fecharEm by remember { mutableIntStateOf(0) }
    val focus = LocalFocusManager.current
    val rotuloSel = opcoes.firstOrNull { it.first == selecionado }?.second ?: selecionado
    val termos = texto.trim().split(' ').filter { it.isNotBlank() }
    // O filtro fica no texto, não no foco: no web o campo perde o foco no clique
    // e, se a lista voltar ao começo, o toque cai em "Selecione" e apaga os dados.
    val filtradas = if (termos.isNotEmpty()) {
        opcoes.filter { (_, r) -> termos.all { Ordenacao.contem(r, it) } }
    } else opcoes
    fun escolher(id: String) {
        geracao++
        onSelect(id)
        aberto = false
        texto = ""
        focus.clearFocus()
    }
    LaunchedEffect(fecharEm) {
        if (fecharEm == 0) return@LaunchedEffect
        val g = geracao
        delay(400)
        if (g == geracao) {
            aberto = false
            texto = ""
        }
    }
    BoxWithConstraints(modifier) {
        val largura = maxWidth
        Column(Modifier.fillMaxWidth()) {
        AppOutlinedTextField(
            value = if (focado) texto else rotuloSel,
            onValueChange = {
                texto = it
                aberto = true
            },
            singleLine = true,
            label = { Text(label) },
            placeholder = { Text(rotuloSel.ifBlank { "Digite para buscar" }, maxLines = 1, overflow = TextOverflow.Ellipsis) },
            trailingIcon = {
                Icon(
                    if (aberto) Icons.Filled.KeyboardArrowUp else Icons.Filled.KeyboardArrowDown,
                    contentDescription = "Abrir lista",
                    modifier = Modifier.clip(RoundedCornerShape(50)).clickable { aberto = !aberto }
                )
            },
            isError = isError,
            supportingText = supportingText,
            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done),
            keyboardActions = KeyboardActions(onDone = { filtradas.firstOrNull()?.let { escolher(it.first) } }),
            modifier = Modifier.fillMaxWidth().onFocusChanged {
                if (it.isFocused && !focado) {
                    geracao++
                    focado = true
                    texto = ""
                    aberto = true
                } else if (!it.isFocused && focado) {
                    focado = false
                    fecharEm++
                }
            },
            colors = FormFieldDefaults.textFieldColors()
        )
        if (embutido && aberto) {
            Column(
                Modifier.fillMaxWidth().heightIn(max = 240.dp).verticalScroll(rememberScrollState())
                    .border(1.dp, PortalCores.Borda, RoundedCornerShape(8.dp)).background(PortalCores.Cartao)
            ) {
                if (filtradas.isEmpty()) {
                    Text("Nada encontrado", color = PortalCores.CinzaTexto, modifier = Modifier.padding(12.dp))
                }
                filtradas.forEach { (id, rotulo) ->
                    Text(
                        rotulo,
                        fontWeight = if (id == selecionado) FontWeight.Bold else FontWeight.Normal,
                        modifier = Modifier.fillMaxWidth().clickable { escolher(id) }.padding(horizontal = 12.dp, vertical = 8.dp)
                    )
                }
            }
        }
        }
        if (!embutido) DropdownMenu(
            expanded = aberto,
            onDismissRequest = { aberto = false },
            properties = PopupProperties(focusable = false),
            modifier = (if (largura < 2000.dp) Modifier.width(largura) else Modifier.widthIn(min = 240.dp)).heightIn(max = 320.dp)
        ) {
            if (filtradas.isEmpty()) {
                DropdownMenuItem(text = { Text("Nada encontrado", color = PortalCores.CinzaTexto) }, onClick = {}, enabled = false)
            }
            filtradas.forEach { (id, rotulo) ->
                DropdownMenuItem(
                    text = { Text(rotulo, fontWeight = if (id == selecionado) FontWeight.Bold else FontWeight.Normal) },
                    onClick = { escolher(id) }
                )
            }
        }
    }
}

/** Tabela com borda e cabeçalho cinza; [linhas] desenha cada linha (use [LinhaTabela]). */
@Composable
fun TabelaPortal(
    cabecalho: @Composable RowScope.() -> Unit,
    antes: @Composable ColumnScope.() -> Unit = {},
    fixar: Boolean = false,
    linhas: @Composable ColumnScope.() -> Unit
) {
    Column(Modifier.fillMaxWidth().border(1.dp, PortalCores.Borda, RoundedCornerShape(10.dp))) {
        val topo: @Composable () -> Unit = {
            Column(Modifier.fillMaxWidth().background(PortalCores.Cartao)) {
                antes()
                Row(
                    Modifier.fillMaxWidth().background(PortalCores.CabecalhoTabela, RoundedCornerShape(topStart = 10.dp, topEnd = 10.dp))
                        .padding(horizontal = 16.dp, vertical = 12.dp),
                    content = cabecalho
                )
            }
        }
        if (fixar) PainelFixo { topo() } else topo()
        linhas()
    }
}

@Composable
fun LinhaTabela(selecionada: Boolean = false, onClick: (() -> Unit)? = null, content: @Composable RowScope.() -> Unit) {
    HorizontalDivider(color = PortalCores.Borda)
    Row(
        Modifier
            .fillMaxWidth()
            .background(if (selecionada) PortalCores.Navy.copy(alpha = 0.05f) else Color.Transparent)
            .let { if (onClick != null) it.clickable { onClick() } else it }
            .padding(horizontal = 16.dp, vertical = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        content = content
    )
}

/** Chip colorido (status). */
@Composable
fun ChipCor(texto: String, cor: Color, modifier: Modifier = Modifier) {
    Text(
        texto,
        color = cor,
        fontWeight = FontWeight.SemiBold,
        style = MaterialTheme.typography.labelMedium,
        maxLines = 1,
        modifier = modifier
            .background(cor.copy(alpha = 0.10f), RoundedCornerShape(8.dp))
            .border(1.dp, cor.copy(alpha = 0.55f), RoundedCornerShape(8.dp))
            .padding(horizontal = 10.dp, vertical = 4.dp)
    )
}

/** Faixa de aviso com botão OK. */
@Composable
fun AvisoFaixa(msg: String, cor: Color = PortalCores.Verde, onOk: () -> Unit) {
    Card(colors = CardDefaults.cardColors(containerColor = cor.copy(alpha = 0.10f))) {
        Row(
            Modifier.fillMaxWidth().padding(horizontal = 14.dp, vertical = 6.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(msg, Modifier.weight(1f), style = MaterialTheme.typography.bodyMedium, color = cor)
            TextButton(onClick = onOk) { Text("OK") }
        }
    }
}

@Composable
fun Campo(
    label: String,
    valor: String,
    numero: Boolean = false,
    linhas: Int = 1,
    somenteLeitura: Boolean = false,
    modifier: Modifier = Modifier.fillMaxWidth(),
    onChange: (String) -> Unit
) {
    AppOutlinedTextField(
        value = valor,
        onValueChange = onChange,
        label = { Text(label) },
        singleLine = linhas == 1,
        minLines = linhas,
        readOnly = somenteLeitura,
        enabled = !somenteLeitura,
        keyboardOptions = if (numero) KeyboardOptions(keyboardType = KeyboardType.Decimal) else KeyboardOptions.Default,
        modifier = modifier,
        colors = FormFieldDefaults.textFieldColors()
    )
}

@Composable
fun Seletor(
    label: String,
    opcoes: List<Pair<String, String>>,
    selecionado: String,
    onSelect: (String) -> Unit,
    modifier: Modifier = Modifier.fillMaxWidth(),
    embutido: Boolean = false
) = SeletorBusca(label, opcoes, selecionado, onSelect, modifier, embutido = embutido)

/** Duas colunas lado a lado quando há largura; senão, uma abaixo da outra. */
@Composable
fun Par(duas: Boolean, a: @Composable (Modifier) -> Unit, b: @Composable (Modifier) -> Unit) {
    if (duas) {
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp)) {
            a(Modifier.weight(1f))
            b(Modifier.weight(1f))
        }
    } else {
        a(Modifier.fillMaxWidth())
        b(Modifier.fillMaxWidth())
    }
}

/** Título de seção dos formulários: azul-marinho, negrito, com linha abaixo (padrão dos cartões do Ativos). */
@Composable
fun TituloSecao(texto: String, modifier: Modifier = Modifier, linha: Boolean = true) {
    Column(modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(texto, color = PortalCores.Navy, fontWeight = FontWeight.Bold, fontSize = 15.sp)
        if (linha) HorizontalDivider(color = PortalCores.Borda)
    }
}

/** Opção de resposta em formato de botão; selecionada fica preenchida com a cor do significado. */
@Composable
fun OpcaoResposta(
    rotulo: String,
    selecionada: Boolean,
    cor: Color,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val forma = RoundedCornerShape(8.dp)
    Box(
        modifier = modifier
            .background(if (selecionada) cor.copy(alpha = 0.12f) else PortalCores.Cartao, forma)
            .border(if (selecionada) 1.5.dp else 1.dp, if (selecionada) cor else PortalCores.BordaCampo, forma)
            .semantics { selected = selecionada }
            .clickable(role = Role.RadioButton, onClick = onClick)
            .padding(horizontal = 12.dp, vertical = 9.dp),
        contentAlignment = Alignment.Center
    ) {
        Text(
            rotulo,
            color = if (selecionada) cor else PortalCores.Texto,
            fontWeight = if (selecionada) FontWeight.Bold else FontWeight.Medium,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

/** Linha de opções de resposta com larguras iguais. */
@Composable
fun <T> LinhaOpcoes(
    opcoes: List<T>,
    selecionada: T?,
    rotulo: (T) -> String,
    cor: (T) -> Color,
    onSelect: (T) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        opcoes.forEach { op ->
            OpcaoResposta(rotulo(op), selecionada == op, cor(op), { onSelect(op) }, Modifier.weight(1f))
        }
    }
}

val FormaBotao: Shape = RoundedCornerShape(10.dp)

@Composable
fun PortalButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    shape: Shape = FormaBotao,
    colors: ButtonColors = ButtonDefaults.buttonColors(),
    elevation: ButtonElevation? = ButtonDefaults.buttonElevation(),
    border: BorderStroke? = null,
    contentPadding: PaddingValues = ButtonDefaults.ContentPadding,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    content: @Composable RowScope.() -> Unit
) = Button(onClick, modifier, enabled, shape, colors, elevation, border, contentPadding, interactionSource, content)

@Composable
fun PortalOutlinedButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    shape: Shape = FormaBotao,
    colors: ButtonColors = ButtonDefaults.outlinedButtonColors(),
    elevation: ButtonElevation? = null,
    border: BorderStroke? = ButtonDefaults.outlinedButtonBorder,
    contentPadding: PaddingValues = ButtonDefaults.ContentPadding,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    content: @Composable RowScope.() -> Unit
) = OutlinedButton(onClick, modifier, enabled, shape, colors, elevation, border, contentPadding, interactionSource, content)

/** Opção de lista (largura total, texto à esquerda), para grupos com muitas opções ou rótulos longos. */
@Composable
fun OpcaoLista(rotulo: String, selecionada: Boolean, onClick: () -> Unit, modifier: Modifier = Modifier) {
    val forma = RoundedCornerShape(8.dp)
    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(if (selecionada) PortalCores.AzulClaro else PortalCores.Cartao, forma)
            .border(1.dp, if (selecionada) PortalCores.AzulIcone else PortalCores.BordaCampo, forma)
            .semantics { selected = selecionada }
            .clickable(role = Role.RadioButton, onClick = onClick)
            .padding(end = 10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        RadioButton(
            selected = selecionada,
            onClick = null,
            modifier = Modifier.padding(10.dp),
            colors = RadioButtonDefaults.colors(selectedColor = PortalCores.AzulIcone)
        )
        Text(
            rotulo,
            color = if (selecionada) PortalCores.Navy else PortalCores.Texto,
            fontWeight = if (selecionada) FontWeight.SemiBold else FontWeight.Normal
        )
    }
}

/** Cor da etiqueta de vínculo: CLT azul, PJ roxo. */
fun corVinculo(v: String): Color = if (v.equals("PJ", ignoreCase = true)) Color(0xFF6A3FA0) else PortalCores.AzulIcone
